<template>
  <div class="seat-state-wrapper">
    <div v-for="data in floorPlanStats" :key="data.label" class="seat-state">
      <div class="state-logo" :style="data.style" />
      <span>{{ workflowLabel(data.label) }}</span>
      <p class="count">{{ workflowLabel(data.count) }}</p>
    </div>
  </div>
</template>
<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { SeatState } from '@/types'
import { isEmpty } from 'lodash'
import { FLOOR_PLAN_STATS_STYLES } from '@/components/tickets/floorPlan.constants'

export default {
  mixins: [WorkflowDisplay],
  name: 'floor-plan-stats',
  props: {
    allOrderItems: {
      type: Array,
      default: () => [],
    },
    initVenueAvailability: {
      type: Object,
      default: () => null,
    },
    selectedSeats: {
      type: Array,
      default: () => [],
    },
    venueSeatIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      SeatState: SeatState,
      styles: FLOOR_PLAN_STATS_STYLES,
    }
  },
  computed: {
    seatStateEntries() {
      return Object.values(this.initVenueAvailability || {})
    },
    seatTicketCounts() {
      return this.allOrderItems.reduce((acc, orderItem) => {
        const sectionSeats = orderItem.sectionSeats || []
        sectionSeats.forEach(seatId => {
          acc[seatId] = (acc[seatId] || 0) + 1
        })

        return acc
      }, {})
    },
    floorPlanCounts() {
      if (!this.initVenueAvailability) {
        return {
          free: 0,
          marked: 0,
          selected: this.selectedSeats.length,
          twoTicketsAdded: 0,
          bookedSold: 0,
          unavailable: 0,
        }
      }

      const free = this.venueSeatIds.filter(id => {
        return !this.initVenueAvailability[id] || this.initVenueAvailability[id].state === SeatState.DISABLED
      }).length
      const marked = this.seatStateEntries.filter(seat => seat.state === SeatState.AVAILABLE).length
      const bookedSold = this.seatStateEntries.filter(
        seat => seat.state === SeatState.SOLD || seat.state === SeatState.HOLD,
      ).length
      const unavailable = this.seatStateEntries.filter(
        seat => seat.state === SeatState.DISABLED || isEmpty(seat),
      ).length
      const twoTicketsAdded = this.venueSeatIds.filter(id => (this.seatTicketCounts[id] || 0) > 1).length

      return {
        free,
        marked,
        selected: this.selectedSeats.length,
        twoTicketsAdded,
        bookedSold,
        unavailable,
      }
    },
    floorPlanStats() {
      return [
        {
          label: 'workflowsAll.free_75f5271',
          count: this.floorPlanCounts.free,
          style: this.styles.free,
        },
        {
          label: 'workflowsAll.marked_99a8606',
          count: this.floorPlanCounts.marked,
          style: this.styles.marked,
        },
        {
          label: 'workflowsAll.selected_9a976fc',
          count: this.floorPlanCounts.selected,
          style: this.styles.selected,
        },
        {
          label: 'workflowsAll.two_tickets_added_c0d33cd',
          count: this.floorPlanCounts.twoTicketsAdded,
          style: this.styles.multiTicket,
        },
        {
          label: 'workflowsAll.booked_sold_e485ebd',
          count: this.floorPlanCounts.bookedSold,
          style: this.styles.sold,
        },
        {
          label: 'workflowsAll.unavailable_2c9c1f7',
          count: this.floorPlanCounts.unavailable,
          style: this.styles.unavailable,
        },
      ]
    },
  },
}
</script>

<style scoped>
.seat-state-wrapper {
  width: fit-content;
  display: flex;
  border-top: 2px solid #f5f5f5;
  padding: 1rem;
  column-gap: 0.5rem;
  gap: 6px;
}
.state-logo {
  height: 1rem;
  width: 1rem;
  align-self: center;
  background: black;
  border-radius: 100rem;
}
span {
  color: var(--Grey-10, #666);
}
.seat-state {
  display: flex;
  align-items: flex-start;
  column-gap: 0.5rem;
  padding: 0.2rem 0.5rem;
}
.count {
  color: var(--Primary-10, #0277bd);
  display: flex;
  padding: 4px;
  margin: 0;
  align-items: center;
  gap: 8px;
  font-family: 'Source Sans Pro';
  font-size: 12px;
  font-style: normal;
  border-radius: 2px;
  background: var(--Primary-50, #f0f6fa);
  font-weight: 400;
  line-height: 150%; /* 18px */
}
</style>
